import React, { useState, useEffect } from 'react';
import Survey from './Survey';
import News from './News';
import IssueReport from './IssueReport';
import Contact from './Contact';
import SurveyReports from './SurveyReports';
import FirstPortCase from './FirstPortCase';
import LegalSurvey from './LegalSurvey';
import './App.css';

const ImageCarousel = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ['/IMG-20250626-WA0008.jpg', '/IMG-20250626-WA0009.jpg'];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  
  return (
    <img src={images[currentImage]} 
         alt="Community documentation" 
         className="img-fluid rounded-4 shadow-lg" 
         style={{maxWidth: '100%', height: 'auto', transition: 'opacity 0.5s ease-in-out'}} />
  );
};

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [navbarOpen, setNavbarOpen] = useState(false);
  
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');
    const hash = window.location.hash.replace('#', '');
    
    if (page) {
      setCurrentPage(page);
    } else if (hash) {
      setCurrentPage(hash);
    }
  }, []);
  
  const navigateToPage = (page) => {
    setCurrentPage(page);
    window.history.pushState({}, '', `?page=${page}`);
    setNavbarOpen(false);
  };

  const renderPage = () => {
    if (currentPage === 'survey') return <Survey />;
    if (currentPage === 'news') return <News />;
    if (currentPage === 'issues') return <IssueReport />;
    if (currentPage === 'contact') return <Contact />;
    if (currentPage === 'reports') return <SurveyReports />;
    if (currentPage === 'cases') return <FirstPortCase />;
    if (currentPage === 'legal-survey') return <LegalSurvey />;
    return (
      <div className="hero-section">
        <div className="hero-pattern"></div>
        <div className="container hero-content">
          <div className="row align-items-center min-vh-100">
            <div className="col-lg-6 col-12 mb-4 mb-lg-0">
              <div className="clean-logo">
                MB
              </div>
              <h1 className="hero-title fade-in">
                Meadow Bank<br/>
                <span style={{color: '#2563eb'}}>Residents Portal</span>
              </h1>
              <p className="hero-subtitle fade-in">
                Your comprehensive community management platform. Access surveys, report issues, and stay informed about your residential community.
              </p>
              <div className="d-flex gap-3 flex-wrap fade-in justify-content-center justify-content-lg-start">
                <button className="btn btn-primary-custom" onClick={() => navigateToPage('survey')}>
                  Take Survey
                </button>
                <button className="btn btn-outline-custom" onClick={() => navigateToPage('issues')}>
                  Report Issues
                </button>
                <button className="btn btn-outline-custom" onClick={() => navigateToPage('legal-survey')}>
                  Legal Survey
                </button>
              </div>
              
              <div className="stats-grid">
                <div className="stat-card fade-in">
                  <div className="stat-number">107</div>
                  <div className="stat-label">Houses</div>
                </div>
                <div className="stat-card fade-in">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Transparency</div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="text-center">
                <ImageCarousel />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container">
          <a className="navbar-brand" href="#" onClick={() => navigateToPage('home')}>Meadow Bank</a>
          <button 
            className="navbar-toggler" 
            type="button" 
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${navbarOpen ? 'show' : ''}`}>
            <div className="navbar-nav ms-auto">
              <a className="nav-link" href="#" onClick={() => navigateToPage('home')}>Home</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('survey')}>Survey</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('issues')}>Report Issues</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('legal-survey')}>Legal Survey</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('reports')}>Reports</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('news')}>News</a>
              <a className="nav-link" href="#" onClick={() => navigateToPage('contact')}>Contact</a>
            </div>
          </div>
        </div>
      </nav>
      {renderPage()}
    </>
  );
}

export default App;